import React, { useEffect, useState, useContext } from "react";
import Swal from "sweetalert2";
import Header from "./Header";
import Footer from "./Footer";
import Menu from "./Menu";

import CompanyService from "../../../services/User/CompanyService";
import LoadingContext from "../../../store/loading-context";
import HttpError from "../../../utill/HttpError";

const Templete = (props) => {
  const loadingCtx = useContext(LoadingContext);

  useEffect(() => {
    fetchData();
  }, []);

  const [company, setCompany] = useState();

  const fetchData = async () => {
    const _company = await CompanyService.getCompanyData();

    if (_company) {
      setCompany(_company);
    }

    // alert(JSON.stringify(_company));

    if (!_company) {
      loadingCtx.startLoading();

      try {
        const responseData = await CompanyService.fetchByDomainName(
          window.location.hostname
        );

        const status = responseData.status;
        const message = responseData.message;

        if (status === "SUCCESS") {
          const data = responseData.data;
          setCompany(data);

          localStorage.setItem("company", JSON.stringify(data));
        } else {
          Swal.fire("Opps!", message, "error");
        }
      } catch (error) {
        const errMsg = HttpError.getError(error);
        Swal.fire("Opps!", errMsg, "error");
      }

      loadingCtx.stopLoading();
    }
  };

  return (
    <div class="wrapper">
      <Header company={company} />
      <Menu company={company} />

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 text-dark">{props.t2}</h1>
              </div>
              {/* /.col */}
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="#">{props.t1}</a>
                  </li>
                  <li className="breadcrumb-item active">{props.t2}</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        {props.children}
      </div>

      <Footer company={company} />
    </div>
  );
};

export default Templete;
